/* tslint:disable */
/* eslint-disable */
/**
 * RoadFootage.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { BountyLocationFromJSON, BountyLocationToJSON, } from './BountyLocation';
import { ModerationStatusFromJSON, ModerationStatusToJSON, } from './ModerationStatus';
import { RelationStatusFromJSON, RelationStatusToJSON, } from './RelationStatus';
/**
 * Check if a given object implements the StaffIncidentReportRelationDto interface.
 */
export function instanceOfStaffIncidentReportRelationDto(value) {
    let isInstance = true;
    return isInstance;
}
export function StaffIncidentReportRelationDtoFromJSON(json) {
    return StaffIncidentReportRelationDtoFromJSONTyped(json, false);
}
export function StaffIncidentReportRelationDtoFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': !exists(json, 'id') ? undefined : json['id'],
        'status': !exists(json, 'status') ? undefined : RelationStatusFromJSON(json['status']),
        'reviewedAt': !exists(json, 'reviewedAt') ? undefined : (json['reviewedAt'] === null ? null : new Date(json['reviewedAt'])),
        'otherIncidentReportId': !exists(json, 'otherIncidentReportId') ? undefined : json['otherIncidentReportId'],
        'otherModerationStatus': !exists(json, 'otherModerationStatus') ? undefined : ModerationStatusFromJSON(json['otherModerationStatus']),
        'otherLocation': !exists(json, 'otherLocation') ? undefined : BountyLocationFromJSON(json['otherLocation']),
        'otherIncidentDateTime': !exists(json, 'otherIncidentDateTime') ? undefined : (new Date(json['otherIncidentDateTime'])),
        'otherIncidentTimezone': !exists(json, 'otherIncidentTimezone') ? undefined : json['otherIncidentTimezone'],
        'otherFormattedAddress': !exists(json, 'otherFormattedAddress') ? undefined : json['otherFormattedAddress'],
        'otherThumbnailUrl': !exists(json, 'otherThumbnailUrl') ? undefined : json['otherThumbnailUrl'],
        'distanceMetres': !exists(json, 'distanceMetres') ? undefined : json['distanceMetres'],
        'timeGapMinutes': !exists(json, 'timeGapMinutes') ? undefined : json['timeGapMinutes'],
        'isFarApart': !exists(json, 'isFarApart') ? undefined : json['isFarApart'],
        'isFarInTime': !exists(json, 'isFarInTime') ? undefined : json['isFarInTime'],
    };
}
export function StaffIncidentReportRelationDtoToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'status': RelationStatusToJSON(value.status),
        'reviewedAt': value.reviewedAt === undefined ? undefined : (value.reviewedAt === null ? null : value.reviewedAt.toISOString()),
        'otherIncidentReportId': value.otherIncidentReportId,
        'otherModerationStatus': ModerationStatusToJSON(value.otherModerationStatus),
        'otherLocation': BountyLocationToJSON(value.otherLocation),
        'otherIncidentDateTime': value.otherIncidentDateTime === undefined ? undefined : (value.otherIncidentDateTime.toISOString()),
        'otherIncidentTimezone': value.otherIncidentTimezone,
        'otherFormattedAddress': value.otherFormattedAddress,
        'otherThumbnailUrl': value.otherThumbnailUrl,
        'distanceMetres': value.distanceMetres,
        'timeGapMinutes': value.timeGapMinutes,
        'isFarApart': value.isFarApart,
        'isFarInTime': value.isFarInTime,
    };
}
